import { MenuCartItem } from "./fullMenuCart";
import { RefundStatus } from "./refundType";

export interface CartType {
  collectBy: string;
  id: string;
  items: CartItem[];
  customerId: string;
  restaurantId: string;
  totalAmount: number;
  totalFees: number;
  yocoFee: number;
  ecoeatsFee: number;
  status: CartStatus;
  transactionId: string;
  orderCollectionNumber?: number;
  orderCollected: boolean;
  isRefundable: boolean;
  refundedAmount: number;
  refundRequestId?: string;
  pendingOrderID?: string;
  usesCustomerSettlement?: boolean;
  // time
  updatedAt: string;
  createdAt: string;
  purcahseStartAt?: string;
  yocoCheckoutCompletedAt?: string;
  yocoPaymentCompletedAt?: string;
  collectedAt?: string;
  refundRequestedAt?: string;
  refundedDecisionAt?: string;
  refundProcessedAt?: string;
  restaurantAcceptedAt?: string;
  restaurantRejectedAt?: string
}

export type CartStatus = "DRAFT" |
  "PAYMENT_PENDING" |
  "PAYMENT_COMPLETE" |
  "RESTAURANT_ACCEPTED_ORDER" |
  "PREPARING_ORDER" |
  "READY_FOR_COLLECTION" |
  "COLLECTED" |
  "FAILED" |
  RefundStatus;

export interface CartItem {
  addedAt: Date; // Timestamp of when the item was added
  restaurantId: string;
  quantity: number;
  menuCartItem: MenuCartItem;
}

export function hasMenuCartItem(o: any): o is { menuCartItem: unknown } {
    return o != null && typeof o === 'object' && 'menuCartItem' in o;
}